import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, CheckSquare } from "lucide-react";
import { http, errMsg } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { QuickLog, TIPOS, TL } from "./QuickLog";

const ICON = Object.fromEntries(TIPOS.map(([k, , I]) => [k, I]));
const fecha = (s) => new Date(s).toLocaleString("es-MX", { dateStyle: "medium", timeStyle: "short" });

const Item = ({ a, onDel, puede }) => {
  const I = ICON[a.tipo];
  return (
    <li className="relative border-l-2 border-[#E2DDD5] pb-5 pl-5" data-testid={`act-item-${a.id}`}>
      <span className="absolute -left-[11px] top-0 grid h-5 w-5 place-items-center rounded-full bg-[#0B2545] text-white"><I size={11} /></span>
      <div className="flex flex-wrap items-baseline gap-x-2 text-xs text-[#5C5850]"><b className="text-sm text-[#111]">{TL[a.tipo]}</b><span>{fecha(a.fecha)}</span><span>· {a.autor}</span>
        {a.duracion_min > 0 && <span>· {a.duracion_min} min</span>}{a.entidad !== "cliente" && <span className="rounded-full bg-[#F2F0EC] px-2 text-[10px]">{a.entidad} · {a.nombre}</span>}
        {a.via === "ai" && <span className="rounded-full bg-[#13315C]/10 px-2 text-[10px] text-[#13315C]">vía IA</span>}
        {puede && <button onClick={() => onDel(a.id)} className="ml-auto text-[#8C867A] hover:text-rose-700" title="Eliminar" data-testid={`act-borrar-${a.id}`}><Trash2 size={13} /></button>}</div>
      <p className="mt-1 whitespace-pre-line text-sm">{a.resultado}</p>
      {a.siguiente_paso && <p className="mt-1 flex items-center gap-1 text-xs text-[#13315C]"><CheckSquare size={12} />{a.siguiente_paso}{a.siguiente_fecha && ` · ${a.siguiente_fecha}`}{a.tarea_id && " · tarea creada"}</p>}
    </li>
  );
};

export const ActividadPanel = ({ entidad, refId }) => {
  const { user } = useAuth();
  const [items, setItems] = useState(null);
  const [err, setErr] = useState(null);
  const load = () => http.get("/actividad", { params: { entidad, ref: refId } }).then((r) => setItems(r.data)).catch((e) => setErr(errMsg(e)));
  useEffect(() => { load(); }, [entidad, refId]); // eslint-disable-line react-hooks/exhaustive-deps
  const del = (id) => http.delete(`/actividad/${id}`).then(() => { toast.success("Actividad eliminada"); load(); }).catch((e) => toast.error(errMsg(e)));
  if (err) return <p className="text-sm text-[#8C867A]" data-testid="act-sin-acceso">{err}</p>;
  const todo = ["master", "admin"].includes(user?.template) || user?.role === "director";
  return (
    <section className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.2fr)]" data-testid="actividad-panel">
      <div className="rounded-2xl border border-[#E2DDD5] bg-white p-4 sm:p-5"><p className="mb-3 text-xs font-semibold uppercase tracking-widest text-[#5C5850]">Registrar</p><QuickLog entidad={entidad} refId={refId} onSaved={load} /></div>
      <div className="min-w-0">
        <p className="mb-3 text-xs font-semibold uppercase tracking-widest text-[#5C5850]">Línea de tiempo <span data-testid="act-total">({items?.length ?? "…"})</span></p>
        {items && !items.length && <p className="text-sm text-[#8C867A]" data-testid="act-vacio">Sin actividades registradas todavía.</p>}
        <ol className="ml-2" data-testid="act-timeline">{(items || []).map((a) => <Item key={a.id} a={a} onDel={del} puede={todo || a.autor_id === user?.id} />)}</ol>
      </div>
    </section>
  );
};
